var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseClick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.984 23.495c.148-.265.246-.369.514-.511l4.686-2.602-10.649-2.855 2.854 10.65 2.6-4.683h-.005zm2.681.683l4.582 4.583c.976.976-.507 2.46-1.487 1.487l-4.578-4.583-3.224 5.798c-.472.844-1.721.648-1.938-.275l-3.983-14.87c-.211-.784.515-1.487 1.283-1.282l14.907 3.996c.916.246 1.046 1.474.24 1.925l-5.798 3.224-.004-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M23.5 1C35.925 1 46 11.075 46 23.5S35.925 46 23.5 46 1 35.925 1 23.5 11.075 1 23.5 1zm0 2.097c-11.265 0-20.403 9.138-20.403 20.403 0 11.265 9.138 20.403 20.403 20.403 11.265 0 20.403-9.138 20.403-20.403 0-11.265-9.138-20.403-20.403-20.403z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClick);
export default __webpack_public_path__ + "static/media/mouse-click.f0f1bb9f.svg";
export { ForwardRef as ReactComponent };